export function formatPhone(value) {
  var phoneNumbers = value.replace(/\D+/g, '');
  if (phoneNumbers.length === 10) {
    phoneNumbers = "8".concat(phoneNumbers);
  }
  return phoneNumbers.replace(/^8|\+7|7/, '+7');
}